import React from "react";
import Card from "@components/ui/Card/Card";
import './Button.scss';

export type ButtonProps = {
    children: React.ReactNode,
    className?: string,
    filled?: boolean,
    size?: 'lg'|'sm',
    textAlign?: 'left'|'center'|'right',
    disabled?: boolean,
    bottomElement?: React.ReactNode,
    onClick?: () => void,
};

function Button(props: ButtonProps) {

    return (
        <>
            <button onClick={props.onClick} className={`${props.className ?? ''} ${props.filled ? 'filled' : ''} ${props.size ?? ''} ${props.bottomElement ? 'topElement' : ''} ${props.textAlign ? 'text-align-' + props.textAlign : ''}`} disabled={props.disabled}>
                {props.children}
            </button>

            {props.bottomElement !== undefined && (
                <Card color="primary" noBorderRadiusTop>
                    {props.bottomElement}
                </Card>
            )}
        </>
    );
}

export default Button;
